import {
  LineChart,
  Line,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  Legend,
} from "recharts";

import { KpiCard } from "../../../Component/OperationComponents/KpiCard";
import { SectionCard } from "../../../Component/OperationComponents/SectionCard";
import { StatusRow } from "../../../Component/OperationComponents/StatusRow";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../../config/api";
import { ValueLoader } from "../../../Component/Common/ValueLoader";
import DatePicker from "react-datepicker";

/* ---------- inline loader ---------- */
const InlineLoader = ({ width = "w-8" }) => (
  <span className={`inline-block align-middle ${width}`}>
    <ValueLoader />
  </span>
);

export default function DashboardView({
  salesTrend,
  retailers,
  tasks,
  setCurrentView,
}) {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [kpis, setKpis] = useState({
    totalAssigned: 0,
    connected: 0,
    notConnected: 0,
    usingProduct: 0,
    notUsingProduct: 0,
    monthSales: 0,
    outstanding: 0,
  });

  const [retailerLineStats, setRetailerLineStats] = useState({
    active: { count: 0, total: 0, percent: 0 },
    connected: { count: 0, total: 0, percent: 0 },
    using: { count: 0, total: 0, percent: 0 },
  });

  const [salesChartType, setSalesChartType] = useState("day"); // day | month
  const [salesChartData, setSalesChartData] = useState([]); 
  const [salesChartLoading, setSalesChartLoading] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(null); // 👈 null by default
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);




  const authUser = JSON.parse(localStorage.getItem("authUserData"));
  const locationMode = authUser?.location_mode;
  const userState = authUser?.state;
  const userDistrict = authUser?.district;

  const getMonthRange = (date) => {
    const from = new Date(date.getFullYear(), date.getMonth(), 1);
    const to = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    return {
      from_date: from.toISOString().split("T")[0],
      to_date: to.toISOString().split("T")[0],
    };
  };

  const formatDayLabel = (value) => {
    // expects YYYY-MM-DD or DD-MM-YYYY
    const date = new Date(value);
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
    });
  };

  const formatMonthLabel = (value) => {
  const date = new Date(value);
  return date.toLocaleDateString("en-IN", { month: "short" });
};


  const getAllDatesOfMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();

    const daysInMonth = new Date(year, month + 1, 0).getDate();

    return Array.from({ length: daysInMonth }, (_, i) => {
      const d = new Date(year, month, i + 1);
      return d.toISOString().split("T")[0]; // YYYY-MM-DD
    });
  };

  const getLast12Months = () => {
  return Array.from({ length: 12 }, (_, i) => {
    const d = new Date();
    d.setMonth(d.getMonth() - (11 - i));
    return d.toISOString().slice(0, 7); // YYYY-MM
  });
};

const getAllMonthsOfYear = (year) => {
  return Array.from({ length: 12 }, (_, i) => {
    const d = new Date(year, i, 1);
    return d.toISOString().slice(0, 7); // YYYY-MM
  });
};



  /* ================= FETCH KPI DASHBOARD ================= */
  const fetchEmployeeDashboard = async () => {
    try {
      setLoading(true);

      const params = {};
      if (locationMode === "state") params.state = userState;
      if (locationMode === "district") params.district = userDistrict;

      const res = await axios.get(
        `${BASE_URL}company/employee-dashboard`,
        { params }
      );

      if (res.data?.success) {
        const d = res.data;
        setKpis({
          totalAssigned: d.assigned_retailers,
          connected: d.connected_retailers.connected,
          notConnected: d.connected_retailers.not_connected,
          usingProduct: d.using_product.using,
          notUsingProduct: d.using_product.not_using,
          monthSales: d.sales.this_month,
          outstanding: d.sales.outstanding,
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  /* ================= FETCH LINE CHART ================= */
  const fetchRetailerLineChart = async () => {
    try {
      const params = {};
      if (locationMode === "state") params.state = userState;
      if (locationMode === "district") params.district = userDistrict;

      const res = await axios.get(
        `${BASE_URL}company/employee-retailer-line-chart`,
        { params }
      );

      if (res.data?.success) {
        setRetailerLineStats(res.data.data);
      }
    } catch (err) {
      console.error("Line chart API failed", err);
    }
  };

//   const fetchSalesChart = async () => {
//   try {
//     setSalesChartLoading(true);

//     const params = {
//       type: salesChartType,
//     };

//     if (locationMode === "state" && userState) {
//       params.states = userState;
//     }

//     if (locationMode === "district" && userDistrict) {
//       params.districts = userDistrict;
//     }

//     const res = await axios.get(
//       `${BASE_URL}company/employee-sales-chart`,
//       { params }
//     );

//     if (res.data?.success) {
//       const { labels, datasets } = res.data.chart;

//       // 🔄 Convert API response to recharts format
//       const formatted = labels.map((label, index) => ({
//         label,
//         sales: datasets[0]?.data[index] || 0,
//         collection: datasets[1]?.data[index] || 0,
//       }));

//       setSalesChartData(formatted);
//     }
//   } catch (err) {
//     console.error("Sales chart API failed", err);
//   } finally {
//     setSalesChartLoading(false);
//   }
// };


// const fetchSalesChart = async () => {
//   try {
//     setSalesChartLoading(true);

//     const params = {
//       type: salesChartType, // default = day
//     };

//     // ✅ ONLY add date range if user selected a month
//     let formatted = [];

//     if (salesChartType === "day" && selectedMonth) {
//       const allDates = getAllDatesOfMonth(selectedMonth);

//       // Map API data by date
//       const apiDataMap = {};
//       labels.forEach((label, index) => {
//         apiDataMap[label] = {
//           sales: datasets[0]?.data[index] || 0,
//           collection: datasets[1]?.data[index] || 0,
//         };
//       });

//       formatted = allDates.map((date) => ({
//         label: formatDayLabel(date),
//         sales: apiDataMap[date]?.sales || 0,
//         collection: apiDataMap[date]?.collection || 0,
//       }));
//     } else {
//       // month-wise OR day-wise without month filter
//       formatted = labels.map((label, index) => ({
//         label:
//           salesChartType === "day"
//             ? formatDayLabel(label)
//             : formatMonthLabel(label),
//         sales: datasets[0]?.data[index] || 0,
//         collection: datasets[1]?.data[index] || 0,
//       }));
//     }

//     if (locationMode === "state" && userState) {
//       params.states = userState;
//     }

//     if (locationMode === "district" && userDistrict) {
//       params.districts = userDistrict;
//     }

//     const res = await axios.get(
//       `${BASE_URL}company/employee-sales-chart`,
//       { params }
//     );

//     if (res.data?.success) {
//       const { labels, datasets } = res.data.chart;

//       const formatted = labels.map((label, index) => ({
//         label:
//           salesChartType === "day"
//             ? formatDayLabel(label)
//             : formatMonthLabel(label),
//         sales: datasets[0]?.data[index] || 0,
//         collection: datasets[1]?.data[index] || 0,
//       }));


//       setSalesChartData(formatted);
//     }
//   } catch (err) {
//     console.error("Sales chart API failed", err);
//   } finally {
//     setSalesChartLoading(false);
//   }
// };

const fetchSalesChart = async () => {
  try {
    setSalesChartLoading(true);

    const params = {
      type: salesChartType,
    };

    if (salesChartType === "day" && selectedMonth) {
      const { from_date, to_date } = getMonthRange(selectedMonth);
      params.from_date = from_date;
      params.to_date = to_date;
    }

    if (locationMode === "state" && userState) {
      params.states = userState;
    }

    if (locationMode === "district" && userDistrict) {
      params.districts = userDistrict;
    }

    const res = await axios.get(
      `${BASE_URL}company/employee-sales-chart`,
      { params }
    );

    if (res.data?.success) {
      const { labels = [], datasets = [] } = res.data.chart;

      let formatted = [];

      // ================= DAY WISE =================

      if (salesChartType === "day") {
        const baseMonth = selectedMonth || new Date(); // 👈 KEY FIX
        const allDates = getAllDatesOfMonth(baseMonth);

        const apiDataMap = {};
        labels.forEach((label, index) => {
          apiDataMap[label] = {
            sales: datasets[0]?.data?.[index] || 0,
            collection: datasets[1]?.data?.[index] || 0,
          };
        });

        formatted = allDates.map((date) => ({
          label: formatDayLabel(date),
          sales: apiDataMap[date]?.sales || 0,
          collection: apiDataMap[date]?.collection || 0,
        }));
      }

      // ================= MONTH WISE =================
      if (salesChartType === "month") {
        const allMonths = getAllMonthsOfYear(selectedYear);

        const apiDataMap = {};
        labels.forEach((label, index) => {
          apiDataMap[label] = {
            sales: datasets[0]?.data?.[index] || 0,
            collection: datasets[1]?.data?.[index] || 0,
          };
        });

        formatted = allMonths.map((month) => ({
          label: formatMonthLabel(month), // Jan, Feb, Mar...
          sales: apiDataMap[month]?.sales || 0,
          collection: apiDataMap[month]?.collection || 0,
        }));
      }


      setSalesChartData(formatted);
    }

  } catch (err) {
    console.error("Sales chart API failed", err);
  } finally {
    setSalesChartLoading(false);
  }
};


useEffect(() => {
  if (!locationMode) return;

  fetchEmployeeDashboard();
  fetchRetailerLineChart();
  fetchSalesChart();
}, [locationMode, userState, userDistrict, salesChartType,selectedMonth]);



  return (
    <div className="space-y-4">
      {/* KPI Row */}
      {/* <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        <KpiCard
          label="Assigned Retailers"
          value={loading ? <InlineLoader /> : kpis.totalAssigned}
        />

        <KpiCard
          label="Connected Retailers"
          value={
            loading ? (
              <InlineLoader width="w-12" />
            ) : (
              `${kpis.connected}/${kpis.totalAssigned}`
            )
          }
          subLabel={
            loading ? <InlineLoader /> : `${kpis.notConnected} not connected`
          }
        />

        <KpiCard
          label="Using Our Product"
          value={loading ? <InlineLoader /> : kpis.usingProduct}
          subLabel={
            loading ? <InlineLoader /> : `${kpis.notUsingProduct} not using`
          }
        />

        <KpiCard
          label="This Month Sales"
          value={
            loading ? (
              <InlineLoader width="w-14" />
            ) : (
              `₹${(kpis.monthSales / 1000).toFixed(1)}k`
            )
          }
        />

        <KpiCard
          label="Total Outstanding"
          value={
            loading ? (
              <InlineLoader width="w-14" />
            ) : (
              `₹${(kpis.outstanding / 1000).toFixed(1)}k`
            )
          }
          subLabel="Follow up for collections"
        />
      </div> */}


       <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
       <KpiCard
        label="Assigned Retailers"
        value={loading ? <InlineLoader /> : kpis.totalAssigned}
        onClick={() =>
          navigate("/oprretail", {
            state: { filter: "assigned" },
          })
        }
      />

      <KpiCard
        label="Connected Retailers"
        value={
          loading ? <InlineLoader width="w-12" /> : `${kpis.connected}/${kpis.totalAssigned}`
        }
        subLabel={
          loading ? <InlineLoader /> : `${kpis.notConnected} not connected`
        }
        onClick={() =>
          navigate("/oprretail", {
            state: { filter: "connected" },
          })
        }
      />

      <KpiCard
        label="Using Our Product"
        value={loading ? <InlineLoader /> : kpis.usingProduct}
        subLabel={
          loading ? <InlineLoader /> : `${kpis.notUsingProduct} not using`
        }
        onClick={() =>
          navigate("/oprretail", {
            state: { filter: "using" },
          })
        }
      />


        <KpiCard
          label="This Month Sales"
          value={
            loading ? (
              <InlineLoader width="w-14" />
            ) : (
              `₹${(kpis.monthSales / 1000).toFixed(1)}k`
            )
          }
        />

        <KpiCard
          label="Total Outstanding"
          value={
            loading ? (
              <InlineLoader width="w-14" />
            ) : (
              `₹${(kpis.outstanding / 1000).toFixed(1)}k`
            )
          }
          subLabel="Follow up for collections"
        />
      </div>

      {/* Charts */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {/* <SectionCard title="Sales vs Collection (Assigned Retailers)">
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={salesTrend}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="month" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line
                  type="monotone"
                  dataKey="sales"
                  stroke="#2563eb"
                  strokeWidth={2}
                />
                <Line
                  type="monotone"
                  dataKey="collection"
                  stroke="#10b981"
                  strokeWidth={2}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </SectionCard> */}

        <SectionCard title="Sales vs Collection (Assigned Retailers)">
          {/* Tabs */}
          <div className="flex gap-2 mb-3">

            {salesChartType === "day" && (
              <div className="mb-3">
                <DatePicker
                  selected={selectedMonth}
                  onChange={(date) => setSelectedMonth(date)}
                  dateFormat="MMMM, yyyy"
                  showMonthYearPicker
                  placeholderText="Select month"
                  className="border rounded px-3 py-1 text-sm cursor-pointer"
                />
              </div>
            )}

            <button
              onClick={() => setSalesChartType("day")}
              className={`px-3 py-1 rounded text-sm ${
                salesChartType === "day"
                  ? "bg-blue-600 text-white"
                  : "bg-slate-100 text-slate-600"
              }`}
            >
              Day Wise
            </button>

            <button
              onClick={() => setSalesChartType("month")}
              className={`px-3 py-1 rounded text-sm ${
                salesChartType === "month"
                  ? "bg-blue-600 text-white"
                  : "bg-slate-100 text-slate-600"
              }`}
            >
              Month Wise
            </button>


          </div>

          <div className="h-64">
            {salesChartLoading ? (
              <div className="h-full flex items-center justify-center">
                <ValueLoader />
              </div>
            ) : (
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={salesChartData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="label" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="sales" fill="#2563eb" name="Total Sales" />
                  <Bar dataKey="collection" fill="#10b981" name="Paid Sales" />
                </BarChart>
              </ResponsiveContainer>
            )}
          </div>
        </SectionCard>

        <SectionCard title="Retailer Status Snapshot">
          <div className="h-64 flex flex-col justify-between">
            <div className="space-y-2 text-sm">
              <StatusRow
                label="Active retailers"
                value={retailerLineStats.active.count}
                total={retailerLineStats.active.total}
              />
              <StatusRow
                label="Connected retailers"
                value={retailerLineStats.connected.count}
                total={retailerLineStats.connected.total}
              />
              <StatusRow
                label="Using product"
                value={retailerLineStats.using.count}
                total={retailerLineStats.using.total}
              />
            </div>
          </div>
        </SectionCard>
      </div>
    </div>
  );
}


// import {
//   LineChart,
//   Line,
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   Tooltip,
//   CartesianGrid,
//   ResponsiveContainer,
//   Legend,
// } from "recharts";

// import { KpiCard } from "../../../Component/OperationComponents/KpiCard";
// import { SectionCard } from "../../../Component/OperationComponents/SectionCard";
// import { StatusRow } from "../../../Component/OperationComponents/StatusRow";
// import { useNavigate } from "react-router-dom";
// import { useEffect, useState } from "react";
// import axios from "axios";
// import { BASE_URL } from "../../../config/api";
// import { ValueLoader } from "../../../Component/Common/ValueLoader";

// /* ---------- inline loader ---------- */
// const InlineLoader = ({ width = "w-8" }) => (
//   <span className={`inline-block align-middle ${width}`}>
//     <ValueLoader />
//   </span>
// );

// const fillMissingDays = (labels, datasets) => {
//   const map = {};

//   labels.forEach((label, i) => {
//     map[label] = {
//       label,
//       sales: datasets[0]?.data[i] || 0,
//       collection: datasets[1]?.data[i] || 0,
//     };
//   });

//   const yearMonth = labels[0]?.slice(0, 7); // "2026-01"
//   const daysInMonth = new Date(
//     Number(yearMonth.split("-")[0]),
//     Number(yearMonth.split("-")[1]),
//     0
//   ).getDate();

//   const result = [];

//   for (let d = 1; d <= daysInMonth; d++) {
//     const day = `${yearMonth}-${String(d).padStart(2, "0")}`;
//     result.push(
//       map[day] || { label: day, sales: 0, collection: 0 }
//     );
//   }

//   return result;
// };


// const fillMissingMonths = (labels, datasets) => {
//   const months = [
//     "Jan","Feb","Mar","Apr","May","Jun",
//     "Jul","Aug","Sep","Oct","Nov","Dec"
//   ];

//   const map = {};

//   labels.forEach((label, i) => {
//     map[label] = {
//       label,
//       sales: datasets[0]?.data[i] || 0,
//       collection: datasets[1]?.data[i] || 0,
//     };
//   });

//   return months.map((m) => (
//     map[m] || { label: m, sales: 0, collection: 0 }
//   ));
// };


// export default function DashboardView({
//   salesTrend,
//   retailers,
//   tasks,
//   setCurrentView,
// }) {
//   const navigate = useNavigate();

//   const [loading, setLoading] = useState(false);

//   const [kpis, setKpis] = useState({
//     totalAssigned: 0,
//     connected: 0,
//     notConnected: 0,
//     usingProduct: 0,
//     notUsingProduct: 0,
//     monthSales: 0,
//     outstanding: 0,
//   });

//   const [retailerLineStats, setRetailerLineStats] = useState({
//     active: { count: 0, total: 0, percent: 0 },
//     connected: { count: 0, total: 0, percent: 0 },
//     using: { count: 0, total: 0, percent: 0 },
//   });

//   const [salesChartType, setSalesChartType] = useState("day"); // day | month
// const [salesChartData, setSalesChartData] = useState([]);
// const [salesChartLoading, setSalesChartLoading] = useState(false);


//   const authUser = JSON.parse(localStorage.getItem("authUserData"));
//   const locationMode = authUser?.location_mode;
//   const userState = authUser?.state;
//   const userDistrict = authUser?.district;

//   /* ================= FETCH KPI DASHBOARD ================= */
//   const fetchEmployeeDashboard = async () => {
//     try {
//       setLoading(true);

//       const params = {};
//       if (locationMode === "state") params.state = userState;
//       if (locationMode === "district") params.district = userDistrict;

//       const res = await axios.get(
//         `${BASE_URL}company/employee-dashboard`,
//         { params }
//       );

//       if (res.data?.success) {
//         const d = res.data;
//         setKpis({
//           totalAssigned: d.assigned_retailers,
//           connected: d.connected_retailers.connected,
//           notConnected: d.connected_retailers.not_connected,
//           usingProduct: d.using_product.using,
//           notUsingProduct: d.using_product.not_using,
//           monthSales: d.sales.this_month,
//           outstanding: d.sales.outstanding,
//         });
//       }
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ================= FETCH LINE CHART ================= */
//   const fetchRetailerLineChart = async () => {
//     try {
//       const params = {};
//       if (locationMode === "state") params.state = userState;
//       if (locationMode === "district") params.district = userDistrict;

//       const res = await axios.get(
//         `${BASE_URL}company/employee-retailer-line-chart`,
//         { params }
//       );

//       if (res.data?.success) {
//         setRetailerLineStats(res.data.data);
//       }
//     } catch (err) {
//       console.error("Line chart API failed", err);
//     }
//   };

//   const fetchSalesChart = async () => {
//   try {
//     setSalesChartLoading(true);

//     const params = {
//       type: salesChartType,
//     };

//     if (locationMode === "state" && userState) {
//       params.states = userState;
//     }

//     if (locationMode === "district" && userDistrict) {
//       params.districts = userDistrict;
//     }

//     const res = await axios.get(
//       `${BASE_URL}company/employee-sales-chart`,
//       { params }
//     );

//     if (res.data?.success) {
//       const { labels, datasets } = res.data.chart;

//         let formatted = [];

//         if (salesChartType === "day") {
//           formatted = fillMissingDays(labels, datasets);
//         } else {
//           formatted = fillMissingMonths(labels, datasets);
//         }

//         setSalesChartData(formatted);
//     }
//   } catch (err) {
//     console.error("Sales chart API failed", err);
//   } finally {
//     setSalesChartLoading(false);
//   }
// };

// useEffect(() => {
//   if (!locationMode) return;

//   fetchEmployeeDashboard();
//   fetchRetailerLineChart();
//   fetchSalesChart();
// }, [locationMode, userState, userDistrict, salesChartType]);



//   return (
//     <div className="space-y-4">
//       {/* KPI Row */}
//       <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
//         <KpiCard
//           label="Assigned Retailers"
//           value={loading ? <InlineLoader /> : kpis.totalAssigned}
//         />

//         <KpiCard
//           label="Connected Retailers"
//           value={
//             loading ? (
//               <InlineLoader width="w-12" />
//             ) : (
//               `${kpis.connected}/${kpis.totalAssigned}`
//             )
//           }
//           subLabel={
//             loading ? <InlineLoader /> : `${kpis.notConnected} not connected`
//           }
//         />

//         <KpiCard
//           label="Using Our Product"
//           value={loading ? <InlineLoader /> : kpis.usingProduct}
//           subLabel={
//             loading ? <InlineLoader /> : `${kpis.notUsingProduct} not using`
//           }
//         />

//         <KpiCard
//           label="This Month Sales"
//           value={
//             loading ? (
//               <InlineLoader width="w-14" />
//             ) : (
//               `₹${(kpis.monthSales / 1000).toFixed(1)}k`
//             )
//           }
//         />

//         <KpiCard
//           label="Total Outstanding"
//           value={
//             loading ? (
//               <InlineLoader width="w-14" />
//             ) : (
//               `₹${(kpis.outstanding / 1000).toFixed(1)}k`
//             )
//           }
//           subLabel="Follow up for collections"
//         />
//       </div>

//       {/* Charts */}
//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
//         {/* <SectionCard title="Sales vs Collection (Assigned Retailers)">
//           <div className="h-64">
//             <ResponsiveContainer width="100%" height="100%">
//               <LineChart data={salesTrend}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="month" />
//                 <YAxis />
//                 <Tooltip />
//                 <Legend />
//                 <Line
//                   type="monotone"
//                   dataKey="sales"
//                   stroke="#2563eb"
//                   strokeWidth={2}
//                 />
//                 <Line
//                   type="monotone"
//                   dataKey="collection"
//                   stroke="#10b981"
//                   strokeWidth={2}
//                 />
//               </LineChart>
//             </ResponsiveContainer>
//           </div>
//         </SectionCard> */}

//         <SectionCard title="Sales vs Collection (Assigned Retailers)">
//           {/* Tabs */}
//           <div className="flex gap-2 mb-3">
//             <button
//               onClick={() => setSalesChartType("day")}
//               className={`px-3 py-1 rounded text-sm ${
//                 salesChartType === "day"
//                   ? "bg-blue-600 text-white"
//                   : "bg-slate-100 text-slate-600"
//               }`}
//             >
//               Day Wise
//             </button>

//             <button
//               onClick={() => setSalesChartType("month")}
//               className={`px-3 py-1 rounded text-sm ${
//                 salesChartType === "month"
//                   ? "bg-blue-600 text-white"
//                   : "bg-slate-100 text-slate-600"
//               }`}
//             >
//               Month Wise
//             </button>
//           </div>

//           <div className="h-64">
//             {salesChartLoading ? (
//               <div className="h-full flex items-center justify-center">
//                 <ValueLoader />
//               </div>
//             ) : (
//               <ResponsiveContainer width="100%" height="100%">
//                 <BarChart data={salesChartData}>
//                   <CartesianGrid strokeDasharray="3 3" />
//                   <XAxis
//                     dataKey="label"
//                     interval={0}              // 🔥 SHOW ALL
//                     angle={salesChartType === "day" ? 0 : 0}
//                     textAnchor="end"
//                     height={salesChartType === "day" ? 60 : 40}
//                   />
//                   <YAxis />
//                   <Tooltip />
//                   <Legend />
//                   <Bar dataKey="sales" fill="#2563eb" name="Total Sales" />
//                   <Bar dataKey="collection" fill="#10b981" name="Paid Sales" />
//                 </BarChart>
//               </ResponsiveContainer>
//             )}
//           </div>
//         </SectionCard>


//         <SectionCard title="Retailer Status Snapshot">
//           <div className="h-64 flex flex-col justify-between">
//             <div className="space-y-2 text-sm">
//               <StatusRow
//                 label="Active retailers"
//                 value={retailerLineStats.active.count}
//                 total={retailerLineStats.active.total}
//               />
//               <StatusRow
//                 label="Connected retailers"
//                 value={retailerLineStats.connected.count}
//                 total={retailerLineStats.connected.total}
//               />
//               <StatusRow
//                 label="Using product"
//                 value={retailerLineStats.using.count}
//                 total={retailerLineStats.using.total}
//               />
//             </div>
//           </div>
//         </SectionCard>
//       </div>
//     </div>
//   );
// }



// import {
//   LineChart,
//   Line,
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   Tooltip,
//   CartesianGrid,
//   ResponsiveContainer,
//   Legend,
// } from "recharts";

// import { KpiCard } from "../../../Component/OperationComponents/KpiCard";
// import { SectionCard } from "../../../Component/OperationComponents/SectionCard";
// import { StatusRow } from "../../../Component/OperationComponents/StatusRow";
// import { useNavigate } from "react-router-dom";
// import { useEffect, useState } from "react";
// import axios from "axios";
// import { BASE_URL } from "../../../config/api";

// export default function DashboardView({ salesTrend, retailers, tasks, setCurrentView }) {
//   const navigate = useNavigate();

//   const [kpis, setKpis] = useState({
// totalAssigned: 0,
// connected: 0,
// notConnected: 0,
// usingProduct: 0,
// notUsingProduct: 0,
// monthSales: 0,
// outstanding: 0,
// });

// const [retailerLineStats, setRetailerLineStats] = useState({
// active: { count: 0, total: 0, percent: 0 },
// connected: { count: 0, total: 0, percent: 0 },
// using: { count: 0, total: 0, percent: 0 },
// });


// const authUser = JSON.parse(localStorage.getItem("authUserData"));
// const locationMode = authUser?.location_mode; // "state" | "district"
// const userState = authUser?.state;             // "MAHARASHTRA"
// const userDistrict = authUser?.district;  


// const fetchEmployeeDashboard = async ({
// location_mode,
// state,
// district,
// }) => {
// try {
//   const params = {};

//   if (location_mode === "state") {
//     params.state = state;
//   }

//   if (location_mode === "district") {
//     params.district = district;
//   }

//   const res = await axios.get(
//     `${BASE_URL}company/employee-dashboard`,
//     { params }
//   );

//   if (res.data?.success) {
//     const d = res.data;

//     setKpis({
//       totalAssigned: d.assigned_retailers,
//       connected: d.connected_retailers.connected,
//       notConnected: d.connected_retailers.not_connected,
//       usingProduct: d.using_product.using,
//       notUsingProduct: d.using_product.not_using,
//       monthSales: d.sales.this_month,
//       outstanding: d.sales.outstanding,
//     });
//   }
// } catch (err) {
//   console.error(err);
// }
// };

// const fetchRetailerLineChart = async ({
// location_mode,
// state,
// district,
// }) => {
// try {
//   const params = {};

//   if (location_mode === "state" && state) {
//     params.state = state;
//   }

//   if (location_mode === "district" && district) {
//     params.district = district;
//   }

//   const res = await axios.get(
//     `${BASE_URL}company/employee-retailer-line-chart`,
//     { params }
//   );

//   if (res.data?.success) {
//     setRetailerLineStats(res.data.data);
//   }
// } catch (err) {
//   console.error("Line chart API failed", err);
// }
// };

// useEffect(() => {
// if (!locationMode) return;

// fetchEmployeeDashboard({
//   location_mode: locationMode,
//   state: userState,
//   district: userDistrict,
// });

// fetchRetailerLineChart({
//   location_mode: locationMode,
//   state: userState,
//   district: userDistrict,
// });
// }, [locationMode, userState, userDistrict]);



//   return (
//     <div className="space-y-4">
//       {/* KPI Row 1 */}
//       <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
//         <KpiCard
//           label="Assigned Retailers"
//           value={kpis.totalAssigned}
//           subLabel={`${kpis.active} active · ${kpis.inactive} inactive`}
//           onClick={() =>
//             navigate("/retailers?filter=assigned", {
//               state: { retailers,
//                 title: "Assigned Retailers"
//               },
//             })
//           }
//         />
//         <KpiCard
//           label="Connected Retailers"
//           value={`${kpis.connected}/${kpis.totalAssigned}`}
//           subLabel={`${kpis.notConnected} not connected`}
//           onClick={() =>
//             navigate("/retailers?filter=connected", {
//               state: { retailers,
//                 title: "Connected Retailers"
//               },
//             })
//           }
//         />
//         <KpiCard
//           label="Using Our Product"
//           value={`${kpis.usingProduct}`}
//           subLabel={`${kpis.notUsingProduct} not using`}
//           onClick={() =>
//             navigate("/retailers?filter=using", {
//               state: { retailers,
//                 title: "Using Our Product"
//               },
//             })
//           }
//         />
//         <KpiCard
//           label="This Month Sales"
//           value={`₹${(kpis.monthSales / 1000).toFixed(1)}k`}
//           subLabel={`Total Assigned: ₹${(kpis.totalSales / 1000).toFixed(1)}k`}
//           onClick={() =>
//             navigate("/retailers?filter=sales", {
//               state: { retailers,
//                 title: "Top Retailers by Sales"
//               },
//             })
//           }
//         />

//         <KpiCard
//           label="Total Outstanding"
//           value={`₹${(kpis.outstanding / 1000).toFixed(1)}k`}
//           subLabel="Follow up for collections"
//           onClick={() => navigate("/retwarnty", { state: { fromKpi: true } })}
//         />
//       </div>

//       {/* KPI Row 2 */}
//       {/* <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
//         <KpiCard
//           label="Total Outstanding"
//           value={`₹${(kpis.outstanding / 1000).toFixed(1)}k`}
//           subLabel="Follow up for collections"
//           onClick={() => navigate("/retwarnty", { state: { fromKpi: true } })}
//         />
//         <KpiCard
//           label="My Open Tasks"
//           value={kpis.openTasks || 0}
//           subLabel={`${kpis.doneTasks} completed`}
//           onClick={() =>
//             navigate("/oprtasks", {
//               state: {
//                 mode: "open",
//                 showForm: false   // ⬅ hide create form
//               }
//             })
//           }
//         />
//         <KpiCard
//           label="Retailer Engagement Score"
//           value={0}
//           subLabel="Based on active & connected retailers"
//         />
//       </div> */}

//       {/* Charts + Activity */}
//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
//         {/* Sales Trend */}
//         <SectionCard
//           title="Sales vs Collection (Assigned Retailers)"
//           right={
//             <button
//               onClick={() => setCurrentView("reports")}
//               className="text-xs text-blue-600 hover:underline"
//             >
//               View reports →
//             </button>
//           }
//         >
//           <div className="h-64">
//             <ResponsiveContainer width="100%" height="100%">
//               <LineChart data={salesTrend}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="month" />
//                 <YAxis />
//                 <Tooltip />
//                 <Legend />
//                 <Line
//                   type="monotone"
//                   dataKey="sales"
//                   name="Sales"
//                   stroke="#2563eb"
//                   strokeWidth={2}
//                 />
//                 <Line
//                   type="monotone"
//                   dataKey="collection"
//                   name="Collection"
//                   stroke="#10b981"
//                   strokeWidth={2}
//                 />
//               </LineChart>
//             </ResponsiveContainer>
//           </div>
//         </SectionCard>

//         {/* Retailer Status */}
//         <SectionCard title="Retailer Status Snapshot">
//           <div className="h-64 flex flex-col justify-between">
//             <div className="space-y-2 text-sm">
//               <StatusRow
//                 label="Active retailers"
//                 value={retailerLineStats.active.count}
//                 total={retailerLineStats.active.total}
//               />

//               <StatusRow
//                 label="Connected retailers"
//                 value={retailerLineStats.connected.count}
//                 total={retailerLineStats.connected.total}
//               />

//               <StatusRow
//                 label="Using product"
//                 value={retailerLineStats.using.count}
//                 total={retailerLineStats.using.total}
//               />
//             </div>
//             <div className="mt-4 text-xs text-slate-500">
//               Tip: Focus on{" "}
//               <span className="font-semibold text-blue-700">
//                 inactive & not connected
//               </span>{" "}
//               retailers to improve engagement.
//             </div>
//           </div>
//         </SectionCard>

//         {/* My Work Today */}
//         {/* <SectionCard
//           title="Today’s Work Snapshot"
//           right={
//             <button
//               onClick={() => setCurrentView("tasks")}
//               className="text-xs text-blue-600 hover:underline"
//             >
//               Go to tasks →
//             </button>
//           }
//         >
//           <div className="h-64 flex flex-col justify-between">
//             <div className="space-y-2 text-sm">
//               {["Open", "In Progress", "Done"].map((status) => {
//                 const filtered = tasks.filter((t) => t.status === status);
//                 return (
//                   <div
//                     key={status}
//                     className="flex items-center justify-between"
//                   >
//                     <div className="flex flex-col">
//                       <span className="font-medium text-slate-700">
//                         {status} tasks
//                       </span>
//                       <span className="text-xs text-slate-500">
//                         {filtered.length
//                           ? filtered
//                               .slice(0, 2)
//                               .map((t) => t.title)
//                               .join(", ") +
//                             (filtered.length > 2 ? "..." : "")
//                           : "No tasks"}
//                       </span>
//                     </div>
//                     <span className="text-lg font-bold text-blue-700">
//                       {filtered.length}
//                     </span>
//                   </div>
//                 );
//               })}
//             </div>
//             <div className="mt-4 text-xs text-slate-500">
//               Complete at least{" "}
//               <span className="font-semibold text-blue-700">5</span> tasks per
//               day to stay on track.
//             </div>
//           </div>
//         </SectionCard> */}
//       </div>
//     </div>
//   );
// }
